// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/category_group.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/category_group.proto.
 */
export const file_travplaces_v1_category_group: GenFile = /*@__PURE__*/
  fileDesc("CiJ0cmF2cGxhY2VzL3YxL2NhdGVnb3J5X2dyb3VwLnByb3RvEg10cmF2cGxhY2VzLnYxIloKDUNhdGVnb3J5R3JvdXASCwoDa2V5GAEgASgJEg0KBWxhYmVsGAIgASgJEhkKEWlzX2luZnJhc3RydWN0dXJlGAMgASgIEhIKCnNvcnRfb3JkZXIYBCABKAUiGwoZTGlzdENhdGVnb3J5R3JvdXBzUmVxdWVzdCJTChpMaXN0Q2F0ZWdvcnlHcm91cHNSZXNwb25zZRI1Cg9jYXRlZ29yeV9ncm91cHMYASADKAsyHC50cmF2cGxhY2VzLnYxLkNhdGVnb3J5R3JvdXAyjgEKFENhdGVnb3J5R3JvdXBTZXJ2aWNlEnYKEkxpc3RDYXRlZ29yeUdyb3VwcxIoLnRyYXZwbGFjZXMudjEuTGlzdENhdGVnb3J5R3JvdXBzUmVxdWVzdBopLnRyYXZwbGFjZXMudjEuTGlzdENhdGVnb3J5R3JvdXBzUmVzcG9uc2UiC4rqMAMKAQqQ6jABQq0BChFjb20udHJhdnBsYWNlcy52MUISQ2F0ZWdvcnlHcm91cFByb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * CategoryGroup is a named, ordered grouping of POI categories. Infrastructure
 * groups are the things a route is planned AROUND rather than towards.
 *
 * @generated from message travplaces.v1.CategoryGroup
 */
export type CategoryGroup = Message<"travplaces.v1.CategoryGroup"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * planned AROUND, not towards
   *
   * @generated from field: bool is_infrastructure = 3;
   */
  isInfrastructure: boolean;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;
};

/**
 * Describes the message travplaces.v1.CategoryGroup.
 * Use `create(CategoryGroupSchema)` to create a new message.
 */
export const CategoryGroupSchema: GenMessage<CategoryGroup> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_category_group, 0);

/**
 * @generated from message travplaces.v1.ListCategoryGroupsRequest
 */
export type ListCategoryGroupsRequest = Message<"travplaces.v1.ListCategoryGroupsRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListCategoryGroupsRequest.
 * Use `create(ListCategoryGroupsRequestSchema)` to create a new message.
 */
export const ListCategoryGroupsRequestSchema: GenMessage<ListCategoryGroupsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_category_group, 1);

/**
 * @generated from message travplaces.v1.ListCategoryGroupsResponse
 */
export type ListCategoryGroupsResponse = Message<"travplaces.v1.ListCategoryGroupsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.CategoryGroup category_groups = 1;
   */
  categoryGroups: CategoryGroup[];
};

/**
 * Describes the message travplaces.v1.ListCategoryGroupsResponse.
 * Use `create(ListCategoryGroupsResponseSchema)` to create a new message.
 */
export const ListCategoryGroupsResponseSchema: GenMessage<ListCategoryGroupsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_category_group, 2);

/**
 * CategoryGroupService exposes the category grouping catalogue.
 *
 * @generated from service travplaces.v1.CategoryGroupService
 */
export const CategoryGroupService: GenService<{
  /**
   * ListCategoryGroups returns every group, by sort order then label.
   *
   * @generated from rpc travplaces.v1.CategoryGroupService.ListCategoryGroups
   */
  listCategoryGroups: {
    methodKind: "unary";
    input: typeof ListCategoryGroupsRequestSchema;
    output: typeof ListCategoryGroupsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_category_group, 0);

